import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "revico-community-talk-post--reviewer-attribute-choice" }
const _hoisted_2 = ["id", "name", "checked", "onClick"]
const _hoisted_3 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.reviewerAttribute.reviewerAttributeChoices, (choice, index) => {
      return (_openBlock(), _createElementBlock("li", {
        class: "revico-community-talk-post--reviewer-attribute-choice-item",
        key: index
      }, [
        _createElementVNode("input", {
          id: $props.uniqueKey + '_' + choice.attributeChoiceId,
          class: "revico-community-talk-post--reviewer-attribute-answer",
          name: $props.reviewerAttribute.reviewerAttributeId,
          type: "radio",
          checked: $setup.isCheckedReviewerAttributeChoice(choice.attributeChoiceId),
          onClick: ($event: any) => ($setup.onclick($event.target as HTMLInputElement, $props.reviewerAttribute.reviewerAttributeId, choice.attributeChoiceId))
        }, null, 8 /* PROPS */, _hoisted_2),
        _createElementVNode("label", {
          class: _normalizeClass(
					$setup.isCheckedReviewerAttributeChoice(choice.attributeChoiceId)
						? 'revico-community-talk-post--reviewer-attribute-answer-label selected'
						: 'revico-community-talk-post--reviewer-attribute-answer-label'
				),
          for: $props.uniqueKey + '_' + choice.attributeChoiceId
        }, _toDisplayString(choice.displayName), 11 /* TEXT, CLASS, PROPS */, _hoisted_3)
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}